import React from 'react';
import PropTypes from 'prop-types';

import './WoWArenaRankPicker.sass';

import {injectIntl} from 'react-intl';
import withMediaQueries from '../../../../containers/withMediaQueries/withMediaQueries';
import VariableStepRange from '../../../controls/variableStepRange/VariableStepRange';
import RestrictedNumberInput from '../../../controls/restrictedNumberInput/RestrictedNumberInput';

@injectIntl
@withMediaQueries({collapsed: '(max-width: 767px)'}, {collapsed: false})
export default class WoWArenaRankPicker2400 extends React.PureComponent {
    static describeRank = rank => rank.toString();

    static minValue = 0;
    static maxValue = 2400;

    static getDefaultValue = () => [0, 1800];

    static marks = {
        0: '0',
        1500: (
            <span>
        1500
        <span className="rc-slider-mark-tooltip">Combatant</span>
      </span>
        ),
        1600: (
            <span>
        1600
        <span className="rc-slider-mark-tooltip">Challenger</span>
      </span>
        ),
        1700: '1700',
        1800: (
            <span>
        1800
        <span className="rc-slider-mark-tooltip">Rival</span>
      </span>
        ),
        1900: '1900',
        2000: '2000',
        2100: (
            <span>
        2100
        <span className="rc-slider-mark-tooltip">Duelist</span>
      </span>
        ),
        2400: '2400'
    };

    static multipliers = [{from: 0, to: 1500, by: 1/10}];

    render() {
        const {intl, collapsed, value, onChange} = this.props;

        return (
            <div>
                <div className="range-inputs">
                    <div className="range-inputs__item">
                        <RestrictedNumberInput
                            label={intl.formatMessage({id: 'section.product.rating.current'})}
                            min={WoWArenaRankPicker2400.minValue}
                            max={WoWArenaRankPicker2400.maxValue}
                            value={value[0]}
                            onChange={newValue => onChange([
                                newValue,
                                value[1]
                            ])}
                        />
                    </div>

                    <div className="range-inputs__divider"/>

                    <div className="range-inputs__item">
                        <RestrictedNumberInput
                            label={intl.formatMessage({id: 'section.product.wanted'})}
                            min={WoWArenaRankPicker2400.minValue}
                            max={WoWArenaRankPicker2400.maxValue}
                            value={value[1]}
                            onChange={newValue => onChange([
                                value[0],
                                newValue
                            ])}
                        />
                    </div>
                </div>

                {!collapsed && (
                    <div className="slider">
                        <VariableStepRange
                            className="rc-slider-wow-arena"
                            step={50}
                            min={WoWArenaRankPicker2400.minValue}
                            max={WoWArenaRankPicker2400.maxValue}
                            multipliers={WoWArenaRankPicker2400.multipliers}
                            marks={WoWArenaRankPicker2400.marks}
                            value={value}
                            onChange={onChange}
                        />
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/wowArena/WowArenaRankPicker2400.js